/** YouTube Thumbnail — document knowledge definition. Pure data. */
export default {
  id: 'youtube-thumbnail',
  name: 'YouTube Thumbnail',
  description: 'A high-contrast click magnet shown beside every video title.',
  purpose: 'Click-Through & Video Discovery',
  recommendedSizes: [{ name: 'HD Thumbnail', width: 1280, height: 720, unit: 'px' }],
  supportedOrientations: ['landscape'],
  supportsMultiplePages: false,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: false,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: false,
  supportsOffers: false,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Background Image', 'Title Text', 'Subject Focus', 'Accent Graphics'],
};
